import { ButtonOutlined } from "../Buttons.elements";
import styled from 'styled-components'
export const OpenCloseToggleButtonContainer = styled(ButtonOutlined)`
   
    display: grid;
    grid-template-columns: max-content auto;
    align-items: center;
    gap: .5em;
    box-shadow: none;
    border-radius: 0;
    .label { font-size: .9em; }
    .icon {
      width: .6em;
      height: .6em;

      path {
        stroke-width: 2;
      }
    }
    &.is-open {
      .icon {
        transform: rotate(180deg);
      }
    }
`